import { render, staticRenderFns } from "./TableInfo.vue?vue&type=template&id=19442ada&"
import script from "./TableInfo.vue?vue&type=script&lang=js&"
export * from "./TableInfo.vue?vue&type=script&lang=js&"
import style0 from "./TableInfo.vue?vue&type=style&index=0&id=19442ada&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports